import {createOrderItemsPayload} from './interfaces';
// Const
import {
  GET_ORDERS,
  GET_ORDER_WITH_ID,
  UPDATE_ORDER_STATUS,
  ACTION_RETRIEVE_RUBIKA_ORDERS,
  CANCEL_ORDER,
  GET_LOGS,
  GET_ALL_ORDERS_REPORT,
  UPDATE_ALL_ORDER_STATUS,
  CREATE_POST_ORDERS,
  GET_ORDER_ITEMS,
  CLEAR_ORDER,
  CREATE_ORDER_ITEMS,
  UPDATE_ORDER,
  RESEND_ORDER,
  GET_CAT,
  GET_TICKETS,
  GET_TICKETCOUNT,
  GET_TICKET,
  CLOSE_TICKET,GET_VITRIN_ORDERS,GET_INCOMING_ORDERS,GET_VITRIN_ORDER_WITH_ID
} from './constants';

// Type
import {Payload, cancelPayload, PayloadAllUpdate} from './interfaces';

export function getOrdersAction(payload: Payload) {
  return {
    type: GET_ORDERS,
    payload,
  };
}
export function getVitrinOrdersAction(payload: Payload) {
  return {
    type: GET_VITRIN_ORDERS,
    payload,
  };
}
export function getIncomingOrdersAction(payload: Payload) {
  return {
    type: GET_INCOMING_ORDERS,
    payload,
  };
}
export function getCatAction(payload: Payload) {
  return {
    type: GET_CAT,
    payload,
  };
}

export function getTicketsAction(payload: Payload) {
  return {
    type: GET_TICKETS,
    payload,
  };
}
export function getTicketAction(payload: Payload) {
  return {
    type: GET_TICKET,
    payload,
  };
}
export function closeTicketAction(payload: Payload) {
  return {
    type: CLOSE_TICKET,
    payload,
  };
}

export function getTicketsCountAction(payload: Payload) {
  return {
    type: GET_TICKETCOUNT,
    payload,
  };
}

export function getAllOrderItemsAction(payload: Payload) {
  return {
    type: GET_ORDER_ITEMS,
    payload,
  };
}
export function resendOrdersAction(payload: Payload) {
  return {
    type: RESEND_ORDER,
    payload,
  };
}

export function createPostOrderAction(payload: Payload) {
  return {
    type: CREATE_POST_ORDERS,
    payload,
  };
}

export function getAllOrdersReportAction(payload: Payload) {
  return {
    type: GET_ALL_ORDERS_REPORT,
    payload,
  };
}

export function getOrderWithIdAction(payload: {id: number}) {
  return {
    type: GET_ORDER_WITH_ID,
    payload,
  };
}

export function getVitrinOrderWithIdAction(payload: {id: number}) {
  return {
    type: GET_VITRIN_ORDER_WITH_ID,
    payload,
  };
}

export function updateOrderStatusActions(payload: {
  id: number;
  body: any;
  pagination: object;
  callback?: () => void;
}) {
  return {
    type: UPDATE_ORDER_STATUS,
    payload,
  };
}

export function actionRetrieveRubikaOrdersAction(payload: {
  date?: string;
  from?: number;
  to?: number;
}) {
  return {
    type: ACTION_RETRIEVE_RUBIKA_ORDERS,
    payload,
  };
}

export function cancelOrderAction(payload: cancelPayload) {
  return {
    type: CANCEL_ORDER,
    payload,
  };
}

export function getLogsAction(payload: {id: number}) {
  return {
    type: GET_LOGS,
    payload,
  };
}

export function updateAllOrderStatusActions(payload: PayloadAllUpdate) {
  return {
    type: UPDATE_ALL_ORDER_STATUS,
    payload,
  };
}

export function createOrderItemsAction(payload: createOrderItemsPayload) {
  return {
    type: CREATE_ORDER_ITEMS,
    payload,
  };
}

export function updateOrderActions(payload: createOrderItemsPayload) {
  return {
    type: UPDATE_ORDER,
    payload,
  };
}

export function clearOrderAction() {
  return {
    type: CLEAR_ORDER,
  };
}
